import './WebsiteSettings.sass';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox, Form, FormItem, Header, InlineHeader, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import { mainSelector } from '$store/main';
import { profileActions } from '$store/profile';

export const WebsiteSettings = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { isWatermarkDisabled } = useSelector(mainSelector);

  return (
    <>
      <Header showBackButton>{t('settings_website_settings')}</Header>
      <ScrollView>
        <Form>
          <InlineHeader>{t('settings_website_settings_watermark_title')}</InlineHeader>
          <FormItem minimize>
            <Checkbox
              checked={!isWatermarkDisabled}
              onClick={() =>
                dispatch(profileActions.toggleIsWatermarkEnabled(!isWatermarkDisabled))
              }
            >
              {t('settings_website_settings_watermark_profile')}
            </Checkbox>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
